export default __webpack_public_path__ + "static/media/instagram.79ea8501.png";